import { render, staticRenderFns } from "./StepWizard.vue?vue&type=template&id=8d5aa5b6"
import script from "./StepWizard.vue?vue&type=script&lang=js"
export * from "./StepWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports